import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { ToastProps } from '../../interfaces/components';
import { ToastContent } from '../../content';

function Toast({ activeLocale, icon, toastActive, borderColor }: ToastProps) {
  return (
    <Box
      bg="white"
      width={['190px', '230px', '250px', '250px', '250px']}
      p={['8px 15px', '8px 15px', '10px 20px', '10px 20px', '10px 20px']}
      border={[`3px  solid ${borderColor}`]}
      top={['15px', '15px', '20px', '20px', '20px']}
      left={['0px', '0px', '90px', '90px', '90px']}
      right={['0px', '0px', 'unset', 'unset', 'unset']}
      m={['0 auto', '0 auto', 'unset', 'unset', 'unset']}
      position="fixed"
      boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
      borderRadius="100px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      opacity={toastActive ? 1 : 0}
      visibility={toastActive ? 'visible' : 'hidden'}
      transition="all 1s"
      zIndex="20"
    >
      {icon}
      <Text
        fontSize={['12px', '14px', '15px', '15px', '15px']}
        fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
      >
        {activeLocale === undefined || !((activeLocale as keyof typeof ToastContent) in ToastContent)
          ? ToastContent['en']
          : ToastContent[activeLocale as keyof typeof ToastContent]}
      </Text>
    </Box>
  );
}

export default Toast;
